<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <div class="overflow-hidden rounded main-height">
      <div class="main-height overflow-auto">
        <div class="flex justify-between">
          <div class="font-bold title mb-2">
            {{ typeName }}
          </div>
          <div class="py-1 px-2 mt-auto cursor-pointer" @click="add()">
            <Icon
              iconName="PlusCircle"
              class="w-8 h-8 text-blue-800"
            />
          </div>
        </div>

        <div class="text-red-700 mb-1 font-bold">
          1行ごとに入力を保存してください
        </div>

        <table class="overflow-auto main table-auto mb-3">
          <thead class="main sticky top-0 bg-white">
            <tr v-if="list && list.length" class="border border-gray-200">
              <th v-for="(c, index) in columns" :key="index" scope="col" class="pl-4 pr-1 py-3 text-xs font-medium text-gray-500 tracking-wider bg-colu text-left whitespace-pre-line" :class="c.class">
                {{c.title}}
              </th>
            </tr>
          </thead>

          <tr v-for="(row, i) in list" :key="i" class="border border-gray-200 tracking-wider hover-color">
            <!-- 卒業年度 -->
            <td v-if="type==3" class="pl-3 pr-1 py-0.5 text-gray-700">
              <input
                type="number"
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-24 py-1.5"
                v-model="row.gradYear"
                @input="edit('gradYear', row)"
              />
            </td>

            <!-- 種別 -->
            <td v-if="type==1||type==3" class="pl-3 pr-1 py-0.5 text-gray-700">
              <select
                name="category"
                v-model="row.category"
                class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
                @change="edit('category', row, $event)"
              >
                <option
                  v-for="c in categoryList" :key='c.name'
                  :value="c.name"
                  class="bg-white">
                  {{ c.name }}
                </option>
              </select>
            </td>

            <!-- 部署名 -->
            <td v-if="type==1||type==3" class="pl-3 pr-1 py-0.5 text-sm text-gray-700">
              <select
                name="department"
                v-model="row.departmentId"
                class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
                @change="edit('department', row, $event)"
              >
                <option
                  v-for="c in departmentList" :key='c.value'
                  :value="c.value"
                  class="bg-white">
                  {{ c.text }}
                </option>
              </select>
            </td>

            <!-- ユーザーID/ChatworkアカウントID -->
            <td v-if="type==2" class="pl-3 pr-1 py-0.5 text-gray-700 text-xs">
              <p>{{ row.userId }}</p>
              <p>{{ row.chatworkAccountId }}</p>
            </td>

            <!-- ユーザー名 -->
            <td v-if="type==2" class="pl-3 pr-1 py-0.5 text-gray-700">
              <WmsSuggestInput
                name="userName"
                :selectionItems="userList"
                displayField="userName"
                v-model="row.userName"
                @selected="staffSelected($event, row)"
                @blur="staffChanged(row)"
              >
              </WmsSuggestInput>
            </td>

            <!-- ルームID -->
            <td class="pl-3 pr-1 py-0.5 text-gray-700">
              <input
                type="number"
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-32 py-1.5"
                v-model="row.roomId"
                @input="edit('roomId', row)"
              />
            </td>

            <!-- トークン -->
            <td class="pl-3 pr-1 py-0.5 text-gray-700">
              <input
                type="text"
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 text-xs w-60 py-2.5"
                v-model="row.apiToken"
                @input="edit('apiToken', row)"
              />
            </td>

            <td class="px-1 py-0.5 text-center text-sm font-medium border-gray">
              <div class="flex justify-center">
                <PrimaryButton text="保存" size="normal" class="w-16 p-1" :disabled="!row.editFlg" :class="!row.editFlg?'bg-gray-300':'bg-blue-800'" @click="save(row)" />
                <PrimaryButton text="削除" size="normal" class="ml-2 w-16 p-1 bg-red-700" @click="remove(row, i)" />
              </div>
            </td>
          </tr>
        </table>

      </div>
      <div v-if="!loading && (!list || !list.length)" class="flex justify-center items-center text-gray-500 font-bold nothing">
        <p class="text-gray-400 font-bold">対象データがありません</p>
      </div>
      <div class="text-transparent">{{reload}}</div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import Icon from '@components/Icon.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import * as requestPostManager from '@managers/requestPostManager'
import * as utils from '@libs/utils'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import * as backend from '@libs/backend'

// 社員面接
const COL1 = [
        {title: '種別'},
        {title: '応募部署（メインタスクの右側）'},
        {title: 'ルームID'},
        {title: 'APIトークン'},
        {title: ''},
      ]

// 清掃員退職
const COL2 = [
        {title: 'ユーザーID\r\nchatworkアカウントID'},
        {title: 'ユーザー名（TO）'},
        {title: 'ルームID'},
        {title: 'APIトークン'},
        {title: ''},
      ]

// 行
const ROW = { editFlg: false, category: '', department: '', departmentId: null, roomId: null, userId: null, userName: null, gradYear: null }

export default {
  components: {
    Modal,
    PrimaryButton,
    Icon,
    WmsSuggestInput
  },

  // type:1 社員面接、2 清掃員退職
  props: ['open', 'type'],

  data() {
    return {
      // ローディング
      loading: false,
      // チャット設定種別
      typeList: [
        { type: 1, name: '中途社員面接専用 Chatwork' },
        { type: 2, name: '清掃員雇い入れ用 Chatwork' },
        { type: 3, name: '新卒社員面接専用 Chatwork' },
      ],
      // チャット設定名
      typeName: null,
      // カラム
      columns: [],
      // リスト
      list: [],
      // 種別リスト
      categoryList: [
        { name: '採用候補', categoryId: 1 },
        { name: '採用', categoryId: 2 },
        { name: '不採用', categoryId: 3 }
      ],
      // 部署名リスト
      departmentList: [],
      // ユーザーリスト
      userList: [],
      reload: 0
    }
  },

  computed: {
  },

  watch: {
    open() {
      if (this.open) {
        this.getData()
      }
    }
  },

  methods: {
    /**
     * 初期にリセット
     */
    closed() {
      // リスト
      this.list = []
      this.loading = false
      this.$emit('close')
    },

    /**
     * リスト取得
     */
    async getData() {
      this.loading = true
      this.typeName = this.typeList[this.type - 1].name
      // 社員面接
      if (this.type == 1 || this.type == 3) {
        // 権限チェック
        const userInfo = this.$store.getters.loginUserData
        const userInfo2 = this.$store.getters.dualPosition
        // チャットマスタ編集権限
        const chatMstAuth = utils.isRegularStaffInterviewChatMstEdit(userInfo, userInfo2)
        if (!chatMstAuth) {
          this.loading = false
          alert('権限がないため表示できません。面接権限がある人、人事部、もしくは限られた人しか表示できません。')
          this.closed()
          return
        }
        this.columns = utils.clone(COL1)
        // 新卒は卒業年度を先頭に追加
        if (this.type == 3) {
          this.columns.unshift({ title: '卒業年度' })
        }
        // 社員面接専用chatworkルームID取得
        this.list = await requestPostManager.getInterviewsChatRoomID(this, this.type)
        // 部署データ取得
        this.departmentList = utils.desiredDepartment(this.$store.getters.departmentList)

      // 清掃員退職
      } else if (this.type == 2) {
        this.userList = []
        this.columns = utils.clone(COL2)
        const res = await backend.searchData('chatworkData/getDCRetire', { userList: true })
        if (res.data.data) {
          this.userList = res.data.data.userList
          this.list = res.data.data.chat
        }
      }
      if (!this.list.length) {
        this.add()
      }
      this.loading = false
    },

    /**
     * 編集ボタンイベント
     * @param item 対象項目名
     * @param row 編集対象データ
     */
    edit(item, row) {
      if (item == 'category') {
        const e = this.categoryList.find((c) => {
          return c.name == row.category
        })
        row.categoryId = e.categoryId
      } else if (item == 'department') {
        // 部署IDから部署名を設定（IDと部署名の両方を保持）
        const d = this.departmentList.find((d) => d.value == row.departmentId)
        row.department = d ? d.text : ''
      }
      row.editFlg = true
      this.reload++
    },

    /**
     * 保存
     * @param row 対象データ
     */
    async save(row) {
      if (this.type == 1 || this.type == 3) {
        if (this.type == 3 && !row.gradYear) {
          await dialogs.showErrorDialog('卒業年度', '未入力です。卒業年度を入力してください。')
          return
        }
        if (!row.category) {
          await dialogs.showErrorDialog('種別', '未選択です。種別を選択してください。')
          return
        }
        if (!row.department) {
          await dialogs.showErrorDialog('部署名', '未選択です。部署名を選択してください。')
          return
        }
      } else if (this.type == 2) {
        if (!row.userName) {
          await dialogs.showErrorDialog('ユーザー名', '未選択です。ユーザー名を選択してください。')
          return
        }
        if (!row.userId) {
          await dialogs.showErrorDialog('ユーザーID取得エラー', 'ユーザーIDが取得できませんでした。再度、ユーザー名を選択してください。')
          return
        }
        if (!row.userId) {
          await dialogs.showErrorDialog('ユーザーID取得エラー', 'ユーザーIDが取得できませんでした。再度、ユーザー名を選択してください。')
          return
        }
      }
      if (!row.roomId) {
        await dialogs.showErrorDialog('ルームID', '未入力です。ルームIDを入力してください。')
        return
      }

      if (this.type == 1 || this.type == 3) {
        // ダブりがないかチェック
        const double = this.list.filter((l) => {
          const same = l.category == row.category && l.department == row.department
          // 新卒は卒業年度も含めて重複判定
          if (this.type == 3) {
            return same && l.gradYear == row.gradYear
          }
          return same
        })
        if (double.length > 1) {
          const target = this.type == 3 ? '卒業年度・種別・部署' : '種別・部署'
          await dialogs.showErrorDialog('重複のため保存不可', `すでに同じ${target}のデータがあります。`)
          return
        }

        // 同じルームIDがないかチェック
        const room = this.list.filter((r) => {
          return r.roomId == row.roomId
        })
        if (room.length > 1) {
          const dia = await dialogs.showConfirmDialog('ルームID重複あり', 'すでに同じルームIDが登録されていますが、よろしいでしょうか？')
          if (dia != 'YES') {
            return
          }
        }
      }

      const saveData = utils.clone(row)
      delete saveData.editFlg

      // ログ登録内容
      let newFlag = true
      if (row._id || row.id) {
        newFlag = false
      }
      let msg = ''
      if (this.type == 1 || this.type == 3) {
        let type = '中途'
        saveData.newGrad = false

        if (this.type == 3) {
          type = `新卒 ${row.gradYear}年卒`
          saveData.newGrad = true
          // 検索条件と型を揃えるため文字列で保存
          saveData.gradYear = String(row.gradYear)
        } else {
          delete saveData.gradYear
        }
        await requestPostManager.saveInterviewsChatRoomID(this, saveData)
        msg = `${row.department} の ${type}『${row.category}』ルームID`
      } else {
        saveData.type = 100
        saveData.insertUser = this.$store.getters.user.id
        await backend.postData('chatworkData/saveChat', saveData)
        msg = `${row.userName}さん`
      }

      logManager.recordingByRegist(this, newFlag, this.typeName, msg)
      await dialogs.showSuccessDialog('保存しました')
      row.editFlg = false
      this.getData()
    },

    /**
     * 削除
     * @param row 対象データ
     * @param i インデックス
     */
    async remove(row, i) {
      // 既に保存済み
      if (row._id || row.id) {
        // ログ登録内容
        let msg = ''

        if (this.type == 1 || this.type == 3) {
          const target = this.type == 3 ? `${row.gradYear}年卒 ${row.department} の『${row.category}』` : `${row.department} の『${row.category}』`
          const res = await dialogs.showConfirmDialog('削除してよろしいですか？', `${target}を削除します。`)
          if (res != 'YES') {
            return
          }
          await requestPostManager.deleteTask(this, row)
          msg = `${target}を削除しました。`
        } else {
          const res = await dialogs.showConfirmDialog('削除してよろしいですか？', `${row.userName}さんを削除します。`)
          if (res != 'YES') {
            return
          }
          await backend.deleteData('chatworkData/deleteChat', row, false)
          msg = `${row.userName}を削除しました。`
        }
        logManager.recording(this, logManager.Loglevel.INFO, this.typeName, '削除', msg)
        await dialogs.showSuccessDialog('削除しました')
      }
      this.list.splice(i, 1)
    },

    /**
     * 追加ボタン
     */
    add() {
      let row = utils.clone(ROW)
      row.apiToken = '12e6247b22aa5826875a69997587ea01'
      this.list.push(row)
    },

    /**
     * 清掃員選択イベント
     */
    staffSelected(e, row) {
      if (e.userName) {
        row.userId = e.userId
        row.chatworkAccountId = e.chatworkAccountId
      }
    },

    /**
     * 清掃員変更イベント
     */
    staffChanged(row) {
      if (!row.userName) {
        row.userId = null
        row.chatworkAccountId = null
      }
    }
  }
}
</script>
<style scoped>
.main-height {
  height: 85vh;
}

.h-95vh {
  height: 95vh;
}

.h-93vh {
  height: 93vh;
}

.main {
  min-width: 700px;
}

.b-top {
  border-top: 1px solid rgb(228, 227, 227);
}

.bg-colu {
  background: #edecf7;
}

.hover-color:hover {
  background: #edecf7 !important;
}

.title {
  color: #7b77b9;
}
</style>